import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    MarkAllNotificationsReadModel,
    MarkNotificationReadModel,
    MyNotificationsPagedModel,
    MyNotificationsRequestModel,
    UnreadNotificationsCountModel,
} from 'core/models/my-notification.model';
import { ApiBaseService } from './api.base.service';

@Injectable({
    providedIn: 'root',
})
export class ApiMyNotificationsService extends ApiBaseService {
    constructor(http: HttpClient) {
        super(http, '/Notifications/My/');
    }

    public getList(params: MyNotificationsRequestModel): Observable<MyNotificationsPagedModel> {
        return this.get<MyNotificationsPagedModel>('', this.toHttpParams(params));
    }

    public getUnreadCount(): Observable<UnreadNotificationsCountModel> {
        return this.get<UnreadNotificationsCountModel>('UnreadCount');
    }

    public markRead(id: number): Observable<MarkNotificationReadModel> {
        return this.patch<MarkNotificationReadModel>(`${id}/Read`, null);
    }

    public markAllRead(): Observable<MarkAllNotificationsReadModel> {
        return this.patch<MarkAllNotificationsReadModel>('Read', null);
    }

    private toHttpParams(params: MyNotificationsRequestModel): HttpParams {
        return Object.entries(params).reduce((httpParams, [key, value]) => {
            if (value === null || value === undefined) {
                return httpParams;
            }

            return httpParams.set(key, String(value));
        }, new HttpParams());
    }
}
